import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { formatDistance } from "@components/Store/StoreSearch/components/list/storeCard/storeDistance/storeDistance.component";

import { HUBO_ICON_URL } from "../../storeDirections.config";
import "./storeDirectionsResult.scss";

type StoreDirectionsResultComponentProps = {
    originLabel: string;
    storeName: string;
    distance: number;
    onChangeOriginClick: () => void;
};

export const StoreDirectionsResultComponent = ({
    originLabel,
    storeName,
    distance,
    onChangeOriginClick,
}: StoreDirectionsResultComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            <div
                className={"store-directions-result__waypoints"}
                onClick={onChangeOriginClick}
            >
                <p className={"store-directions-result__waypoints__waypoint"}>
                    <i className={"las la-map-marker"} />
                    <span dangerouslySetInnerHTML={{ __html: originLabel }} />
                </p>
                <i
                    className={
                        "store-directions-result__waypoints__direction las la-lg la-arrow-right"
                    }
                />
                <p className={"store-directions-result__waypoints__waypoint"}>
                    <img src={HUBO_ICON_URL} width="16" height="16" />
                    <span>Hubo {storeName}</span>
                </p>
            </div>
            <p className={"store-directions-result__distance"}>
                {t("storeDirections.result.routeLength")}
                <span className={"store-directions-result__distance__value"}>
                    {formatDistance(distance)}
                </span>
            </p>
            <Button
                type={"button"}
                color={"link"}
                onClick={onChangeOriginClick}
                className={"store-directions-result__change-origin"}
            >
                <i className={"las la-angle-left"} />
                {t("storeDirections.result.changeOrigin")}
            </Button>
        </>
    );
};
